exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cursor-pointer {\n  cursor: pointer; }\n\n.color-white {\n  color: #fff; }\n", ""]);

